export enum ReportStatus {
  Created = 1,
  Generating = 2,
  Updated = 3,
  Updating = 4,
  Ready = 5,
  Expired = 6
}

(ReportStatus as any).__typeName = 'ReportStatus';

export function isSalesReportViewable(status?: ReportStatus | null): boolean {
  return status === ReportStatus.Ready || status === ReportStatus.Expired;
}
